import React from "react";
import { DateFormatter } from "../lib/components/Formatters";

const cellWidthSmall = 70;
const cellWidthMedium = 140;
const cellWidthMediumX = 110;
const cellWidthLarge = 220;

const defaultColumnProperties = {
    resizable: true,
    sortable: true,
};

let currentSpace = true;

export const SailingScheduleColumns = (
    data = [],
    filters = {},
    arrangement = [],
    columnsWidth = {},
    vesseloptions = [],
    portoptions = [],
    shippinglines = [],
    additionalColumns = []
) => {
    let postValue = "";

    if (data && data.length > 0) {
        if (currentSpace) {
            postValue = " ";
        }
        currentSpace = !currentSpace;
    }

    const columns = [
        {
            key: "market",
            name: "Market" + postValue,
            width: cellWidthSmall,
        },
        {
            key: "port_of_loading",
            name: "Port of Loading" + postValue,
            width: cellWidthMedium,
        },
        {
            key: "etd",
            name: "ETD" + postValue,
            width: cellWidthMediumX,
            formatter: DateFormatter,
        },
        {
            key: "vessel",
            name: "Vessel" + postValue,
            width: cellWidthMedium,
        },
        {
            key: "voyage",
            name: "Voyage" + postValue,
            width: cellWidthSmall,
        },
        {
            key: "line",
            name: "Line" + postValue,
            width: cellWidthSmall,
        },
        {
            key: "line_service",
            name: "Line Service" + postValue,
            width: cellWidthMedium,
        },
        {
            key: "stacks",
            name: "Stacks" + postValue,
            width: cellWidthLarge,
        },
    ].map((c) => ({ ...c, ...defaultColumnProperties }));

    let allColumns = [...columns, ...additionalColumns];

    let columnsArranged = [...allColumns];

    return columnsArranged;
};